import "core-js/modules/es.number.constructor";
import _CountDown from "@kibt/meta-ui/es/count-down";
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  components: {
    CountDown: _CountDown
  },
  filters: {
    formatTime: function formatTime(val) {
      if (val < 10) {
        return "0".concat(val);
      }

      return val;
    }
  },
  props: {
    time: {
      type: Number,
      default: -1
    },
    colorful: {
      type: Boolean,
      default: true
    },
    big: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(_, ctx) {
    var finish = function finish() {
      if (_.time === -1) return;
      ctx.emit('onFinish', true);
    };

    return {
      finish: finish
    };
  }
});